(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Smooth open/close for every theme accordion row (native details/summary). */
    if (window.__powAccordion) return;
    window.__powAccordion = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var EASE = 'cubic-bezier(0.2, 0.7, 0.2, 1)';

    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.accordion > .accordion__summary');
      if (!summary || reduce.matches || typeof Element.prototype.animate !== 'function') return;
      var details = summary.parentElement;
      var content = details.querySelector(':scope > .accordion__content');
      if (!content) return;
      e.preventDefault();
      var opening = !details.open || details._closing;
      var start = content.offsetHeight;
      if (details._anim) details._anim.cancel();
      details._closing = false;

      if (opening) {
        if (!details.open) start = 0;
        details.open = true;
        var h = content.offsetHeight;
        details._anim = content.animate(
          [{ height: start + 'px', opacity: start ? 1 : 0 }, { height: h + 'px', opacity: 1 }],
          { duration: 300, easing: EASE }
        );
        details._anim.onfinish = function () { details._anim = null; };
      } else {
        details._closing = true;
        details._anim = content.animate(
          [{ height: start + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 240, easing: EASE }
        );
        details._anim.onfinish = function () {
          details.open = false;
          details._closing = false;
          details._anim = null;
        };
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
